import React from 'react';
import { GlobalAlertShowOption, ButtonOption } from '../GlobalAlert/interface';
import AlertPrescriptionModified from '@/components/AlertPrescriptionModifiedModal/AlertPrescriptionModified';

interface GlobalAlertPrescriptionModifiedShowOption
  extends Omit<GlobalAlertShowOption, 'title'> {
  title: string;
  orderId: string;
  orderExternalId: string;
}

interface GlobalAlertPrescriptionModifiedState {
  isVisible: boolean;
  onShow?: () => void;
}

export type GlobalAlertPrescriptionModifiedProps = {
  isVisible?: boolean;
  onShow?: () => void;
  title?: string;
  body?: string;
  orderId?: string;
  orderExternalId?: string;
  isPaid?: boolean;
};

export type AlertPrescriptionModifiedProps = {
  isVisible: boolean;
  title?: string;
  body?: string;
  orderExternalId?: string;
  isPaid?: boolean;
};

const defaultState: GlobalAlertPrescriptionModifiedState = {
  isVisible: false,
  onShow: undefined
};

export default class GlobalAlertPrescriptionModified extends React.Component<
  GlobalAlertPrescriptionModifiedProps,
  GlobalAlertPrescriptionModifiedState
> {
  static _ref: GlobalAlertPrescriptionModified;

  static setRef(ref: GlobalAlertPrescriptionModified) {
    GlobalAlertPrescriptionModified._ref = ref;
  }

  static getRef() {
    return GlobalAlertPrescriptionModified._ref;
  }

  static getVisible() {
    return GlobalAlertPrescriptionModified._ref.state.isVisible;
  }

  static show(options: {
    orderExternalId: string;
    isPaid: boolean | undefined;
    orderId: string;
    title: string;
    body: string;
  }) {
    GlobalAlertPrescriptionModified._ref.show(options);
  }

  static hide() {
    GlobalAlertPrescriptionModified._ref.hide();
  }

  constructor(props: GlobalAlertPrescriptionModifiedProps) {
    super(props);
    this.state = defaultState;
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
  }

  show(options: GlobalAlertPrescriptionModifiedShowOption) {
    this.setState(() => ({
      isVisible: true,
      clickOverlayToClose: false,
      ...options
    }));
  }

  hide() {
    this.setState(() => ({ ...defaultState }));
  }

  getVisible() {
    return this.state.isVisible;
  }

  render() {
    this.state.onShow && this.state.onShow();

    return <AlertPrescriptionModified {...this.props} {...this.state} />;
  }
}
